import React from 'react';
const _ = require('lodash');
const moment = require('moment');

const WebhookFormData = ({ webhookFormData }) => {
  const formatValue = (key, value) => {
    if (key === 'leadGeneratedAt') {
      return moment(value).format('MMMM Do YYYY, h:mm:ss a');
    }
    return value;
  };

  if (webhookFormData && Object.keys(webhookFormData).length > 0) {
    return (
      <div className="p-3">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="bg-light">
              <tr>
                <th className="smallFont">Key</th>
                <th className="smallFont">Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(webhookFormData).map(([key, value]) => {
                const capitalizedKey = _.startCase(key);
                const formattedValue = formatValue(key, value);
                const isUrl = key.toLowerCase() === 'pageUrl';
                return (
                  <tr key={key}>
                    <td className="smallFont">
                      <strong>{capitalizedKey}</strong>
                    </td>
                    <td className="smallFont">
                      {isUrl && formattedValue ? (
                        <a
                          href={formattedValue}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-underline"
                          style={{ cursor: 'pointer', color: '#0000EE' }}
                        >
                          {formattedValue}
                        </a>
                      ) : (
                        formattedValue || 'N/A'
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <p className="text-muted text-center mt-4">No webhook form data available for this lead</p>
    </div>
  );
};

export default WebhookFormData;
